export default {
  async cashbacks(config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/personal/users/transaction/cashbacks`,
      headers: this.headers,
      ...config,
    });
  },
};
